import { motion } from 'framer-motion';
import { Col, Row } from 'antd';
import React from 'react';
import '../assets/css/home.css';

const imagePaths = {
  checked: require('../assets/images/checked.svg').default,
  iphone: require('../assets/images/AJ-Final.webp'),
};

export default function SBProBannerAd({ animated = false }) {
  const variantLeft = {
    visible: {
      x: 0,
      transition: {
        type: 'spring',
        bounce: 0.3,
        duration: 0.8,
      },
    },
    hidden: { x: '-100vw' },
  };

  return (
    <div className=' sb-pro-ad-container sb-blue-bg-800'>
      <motion.div
        initial={animated ? 'hidden' : 'visible'}
        whileInView='visible'
        viewport={{ once: true, amount: 0.25 }}
      >
        <Row className='main_container_padding__content'>
          <Col span={0} xl={12}>
            <motion.div
              variants={animated ? variantLeft : undefined}
              animate={
                animated ? undefined : { x: 0, transition: { duration: 0 } }
              }
              initial={animated ? undefined : variantLeft.hidden}
              // animate={animated ? 'hidden' : 'visible'}
            >
              <img
                src={imagePaths.iphone}
                alt='iphone'
                loading='lazy'
                className='iphone-sb-image'
              />
            </motion.div>
          </Col>
          <Col span={24} xl={12}>
            <div className='fs-26 font-montserrat white txt-center '>
              <span style={{ fontWeight: 700 }}>Level Up Your Angling - </span>
              Join swimbooker+
            </div>
            <Row
              gutter={[10, 0]}
              className='fs-18 sb-blue-100 gMedium mg-20 sb-bullets mg-bottom-40 justify-end'
            >
              <Col span={24} md={10}>
                <div className='mg-bottom-10'>
                  <img
                    src={imagePaths.checked}
                    alt='checked-mark'
                    className='mg-right-10'
                  />
                  Angling Insurance Cover
                </div>
                <div className='mg-bottom-10'>
                  <img
                    src={imagePaths.checked}
                    alt='checked-mark'
                    className='mg-right-10'
                  />
                  Weekly Giveaway
                </div>
                <div className='mg-bottom-10'>
                  <img
                    src={imagePaths.checked}
                    alt='checked-mark'
                    className='mg-right-10'
                  />
                  Cashback On Fishing
                </div>
              </Col>
              <Col span={24} md={12}>
                <div className='mg-bottom-10'>
                  <img
                    src={imagePaths.checked}
                    alt='checked-mark'
                    className='mg-right-10'
                  />
                  Exclusive Perks & Discounts
                </div>
                <div className='mg-bottom-10'>
                  <img
                    src={imagePaths.checked}
                    alt='checked-mark'
                    className='mg-right-10'
                  />
                  InSession Digital Tool
                </div>
                <div className='mg-bottom-10'>
                  <img
                    src={imagePaths.checked}
                    alt='checked-mark'
                    className='mg-right-10'
                  />
                  Advanced Catch Report Data
                </div>
              </Col>
            </Row>
            <div className='row-center gap-2r w-full justify-center'>
              <a
                href={`${process.env.REACT_APP_SBPLUS_URL}/sign-up`}
                className='learn-more-button '
              >
                Learn More
              </a>
              <a
                href={`${process.env.REACT_APP_SBPLUS_URL}/sign-up#plans`}
                className='hover:sb-blue-300 sb-blue-100 fs-18 gBold txt-underline'
              >
                View Pricing
              </a>
            </div>
          </Col>
        </Row>
      </motion.div>
    </div>
  );
}
